import { Box } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(3.75, 0),
  '& .ERHSERLogo, .ERHSESLogo': {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 'fit-content',
    marginLeft: 'auto',
    padding: theme.spacing(0, 2),
  },
  '& .ERHSESLogo': {
    marginLeft: 'unset',
    marginRight: 'auto',
    '& .IBimgbox': {
      width: theme.spacing(20),
      [theme.breakpoints.down('sm')]: {
        width: theme.spacing(14),
      },
    },
  },
  '& .ERHSERLogo': {
    position: 'relative',
    '&:after': {
      content: '""',
      background: theme.palette.grey[200],
      height: '100%',
      width: theme.spacing(0.25),
      position: 'absolute',
      top: 0,
      right: 0,
    },
    '& .IBimgbox': {
      width: theme.spacing(20),
      [theme.breakpoints.down('sm')]: {
        width: theme.spacing(14),
        height: theme.spacing(3),

      },
    },
  },
  '& .ERHSText': {
    marginTop: theme.spacing(1.25),
    color: theme.palette.grey[900],
  },
  '& .ERHSDesc': {
    marginTop: theme.spacing(3),
    padding: theme.spacing(0, 2),
    maxWidth: theme.spacing(100),
    marginLeft: 'auto',
    marginRight: 'auto',
    lineHeight: theme.spacing(3),
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 3),
    },
  },
}));
export default StyledBox;
